import { siteBrand } from "../../../mocks/gossip";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative flex min-h-[640px] w-full items-center overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage:
          "url(https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20background%20of%20interconnected%20network%20nodes%20and%20thin%20lines%20in%20terracotta%20amber%20and%20cream%20tones%2C%20soft%20grain%20texture%2C%20digital%20magazine%20aesthetic%2C%20gentle%20depth%2C%20no%20text&width=1600&height=900&seq=gossip-hero-bg&orientation=landscape)",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-[#fbf6ef]/85 via-[#fbf6ef]/70 to-[#fbf6ef]"></div>

      <div className="relative mx-auto w-full max-w-6xl px-4 md:px-6 pb-14 pt-28">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#e2c9ab] bg-[#fff]/70 px-3 py-1 text-sm text-[#8a5a20]">
          <i className="ri-sparkling-2-line" aria-hidden="true"></i>
          <span className="whitespace-nowrap">人物关系 · 当事人关联图谱全解析</span>
        </div>

        <h1 className="mt-6 max-w-4xl font-serif-sc text-4xl leading-tight font-black text-[#2a2320] md:text-6xl md:leading-[1.1]">
          吃瓜门，一张图看清
          <span className="relative mx-1 inline-block text-[#b4372a]">
            谁是谁
            <span className="absolute -bottom-1 left-0 h-1 w-full rounded bg-[#d9a06b]/60"></span>
          </span>
          、谁连着谁
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#5a5049] md:text-lg">
          从事件当事人到经纪、公关、媒体、品牌与资本，层层连线背后藏着怎样的关系网络？
          本页以可交互图谱梳理吃瓜门核心人物与关联方，标注关系类型与疏密，帮你快速还原整体结构。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#graph"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-[#b4372a] px-6 py-3 text-sm font-semibold whitespace-nowrap text-white transition hover:bg-[#98301f]"
          >
            展开关系图谱 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
          <a
            href="#timeline"
            className="inline-flex items-center justify-center gap-2 rounded-md border border-[#e2c9ab] bg-[#fff]/70 px-6 py-3 text-sm font-semibold whitespace-nowrap text-[#5a5049] transition hover:bg-[#efe3d2]"
          >
            查看时间脉络
          </a>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { num: "4", label: "核心相关人物" },
            { num: "6", label: "关联方 / 机构" },
            { num: "12", label: "关系连线" },
            { num: "5", label: "事件阶段" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-[#eadccb] bg-[#fff]/80 px-5 py-4"
            >
              <dt className="text-2xl font-bold text-[#b4372a] font-serif-sc">{s.num}</dt>
              <dd className="mt-1 text-sm text-[#7a6f66]">{s.label}</dd>
            </div>
          ))}
        </dl>

        <p className="sr-only">{siteBrand} 人物关系与当事人关联图谱全解析</p>
      </div>
    </section>
  );
}